import TopHorizontalMenu from './TopHorizontalMenu'

export default TopHorizontalMenu
